import { router } from '@/routes'
import { LoadingRoute } from '@/routes/LoadingRoute.tsx'
import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'

export function App() {
  return (
    <Suspense fallback={<LoadingRoute />}>
      <RouterProvider router={router()} />
    </Suspense>
  )
}
